import React from 'react';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ItemOptionLabel = ({ action }) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { label, image } = action;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { src, width, alt } = image;
  return (
    <>
      <img src={src} alt={alt} style={{ width: width || '25px' }} />
      {label}
    </>
  );
};

export default React.memo(ItemOptionLabel);
